import type { IUseModal } from "@fluidattacks/design";
import { Container, Link, Modal, Text } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";

interface ICustomFixModalProps {
  modalRef: IUseModal;
}

const prefix = "searchFindings.tabVuln.contentTab.customFix.modal.";

const CustomFixModal = ({
  modalRef,
}: Readonly<ICustomFixModalProps>): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal modalRef={modalRef} size={"sm"} title={t(`${prefix}title`)}>
      <Container display={"flex"} flexDirection={"column"} gap={1.5}>
        <Text size={"md"}>{t(`${prefix}text`)}</Text>
        <Container display={"flex"} flexDirection={"column"} gap={0.25}>
          <Text size={"md"}>
            {t(`${prefix}list.titleFeature`)}
            <b>{t(`${prefix}list.titleAvailable`)}</b>
            {t(`${prefix}list.titleMakeSure`)}
          </Text>
          <Container
            display={"flex"}
            flexDirection={"column"}
            gap={0.25}
            ml={0.5}
          >
            <Text size={"md"}>{`• ${t(`${prefix}list.item1`)}`}</Text>
            <Text size={"md"}>{`• ${t(`${prefix}list.item2`)}`}</Text>
          </Container>
        </Container>
        <Text mb={4} size={"md"}>
          {t(`${prefix}footer`)}
          &nbsp;
          <Link color={"primary"} href={t(`${prefix}footerLink`)}>
            {t(`${prefix}footerLinkText`)}
          </Link>
        </Text>
      </Container>
    </Modal>
  );
};

export { CustomFixModal };
